import signin from "../../assets/signin.jpg";
import home from "../../assets/home.jpg";

const theme = {
  colors: {
    //Header
    headerBackground: "rgba(0, 0, 0, 0.7)",
    navbarText: "#fff",

    //Home
    homeBackground: `url(${home}) no-repeat center`,
    homeButtonBackground: "#222324",
    homeButtonBorder: "#4cd964",
    homeButtonText: "#f2f2f2",

    //Modal
    modalBackground: "#222324",
    modalText: "#fff",
    //Modal-Button
    modalButtonBackground: "#222324",
    modalButtonText: "#fff",

    //SignIn
    signinBackground: `url(${signin}) no-repeat center`,
    signinFormBackground: "rgba(0, 0, 0, 0.6)",
    signinFormBorder: "#e0e1e2",
    signinFormInputBackground: "#f2f2f2",
    signinFormText: "#fff",
    //SignIn-Button-Submit
    signinFormButtonSubmittedBackground: "#997c3b",
    signinFormButtonSubmittedText: "#fff",
     //SignUp-Button-Signin
     signinFormButtonSigninBackground: "transparent",
     signinFormButtonSigninText: "#fff",

    //SignUp
    signupBackground: `url(${signin}) no-repeat center`,
    signupFormBackground: "rgba(0, 0, 0, 0.6)",
    signupFormBorder: "#e0e1e2",
    signupFormInputBackground: "#f2f2f2",
    signupFormText: "#fff",
    //SignUp-Button-Submit
    signupFormButtonSubmittedBackground: "#997c3b",
    signupFormButtonSubmittedText: "#fff",
    //SignUp-Button-Signin
    signupFormButtonSigninBackground: "transparent",
    signupFormButtonSigninText: "#fff",
  },
};

export default theme;
